export const LOGO_URL = `${process.env.PUBLIC_URL || ""}/logo-transparent.png`;

export const SLOGAN = "Architects of Ambition. Builders of Legacy.";

export const CONTACT_EMAIL = "partnerships@madisonpricegroup.com";
export const CONTACT_PHONE = "(505) 210-8055";
export const CONTACT_PHONE_HREF = "tel:+15052108055";

export const NAV_LINKS = [
  { label: "Portfolio", href: "#portfolio" },
  { label: "Philosophy", href: "#philosophy" },
  { label: "Growth", href: "#growth" },
  { label: "Contact", href: "#contact" },
];

export const PORTFOLIO = [
  {
    key: "oliveup",
    index: "01",
    name: "OliveUp",
    category: "Capital / Small Business Lending",
    description:
      "Financing built for the founder. OliveUp puts working capital in the hands of small business owners so they can hire, stock, expand and seize the moment without waiting on a bank.",
    link: "https://getoliveup.com",
    accent: "var(--mpg-olive)",
    image:
      "https://images.pexels.com/photos/3933017/pexels-photo-3933017.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    key: "greenhalo",
    index: "02",
    name: "My Green Halo",
    category: "Advertising / Marketing",
    description:
      "Creative that cuts through the noise. My Green Halo builds advertising and marketing campaigns that turn attention into growth for the brands it partners with.",
    link: "https://mygreenhalo.com",
    accent: "var(--mpg-halo)",
    image:
      "https://images.pexels.com/photos/7688106/pexels-photo-7688106.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "The Thesis",
    body: "We invest in foundational value — businesses that solve real problems for real people, built to compound over decades rather than quarters.",
  },
  {
    n: "02",
    title: "The Approach",
    body: "Capital paired with creative acceleration. Each company keeps its identity while gaining the backing, discipline and long-term vision of a committed parent.",
  },
  {
    n: "03",
    title: "The Horizon",
    body: "We build entities that outlast trends. Our portfolio is designed to grow — deliberately, and with intention — as we welcome new companies into the group.",
  },
];
